require("roc-slot/spingames");
require("roc-slot/common/feature-freespin");
require("./js/addPays.js");
//require("./js/fancy_belly.js");
require("./css/game.css");
//require("./css/fancy_belly.css");
require("./css/desktop.css");
require("./css/mobile.css");

$.ready(function() {
	game.dimensions.width  = 1920;
	game.dimensions.height = 1080;

	game.panel.buildHelp(9);
	
	/* globals spinDone */
	game.sounds.loadSounds({
		// _base: base,
		konami_bell: require("./sounds/FeatureTrigger.mp3"),
		bannerIntro2: require("./sounds/BannerIntro2.mp3"),
		bell: require("./sounds/FeatureTrigger.mp3"),
		trigger: require("./sounds/bell.mp3"),
		drop: {
			12: [
				require("./sounds/drop/12/ScatterOrchHit01.mp3"),
				require("./sounds/drop/12/ScatterOrchHit02.mp3"),
				require("./sounds/drop/12/ScatterOrchHit03.mp3"),
				require("./sounds/drop/12/ScatterOrchHit04.mp3"),
				require("./sounds/drop/12/ScatterOrchHit05.mp3"),
			],
		},
		reel: [
			require("./sounds/reel/reel.mp3"),
			require("./sounds/reel/reel.mp3"),
			require("./sounds/reel/reel.mp3"),
			require("./sounds/reel/reel.mp3"),
			require("./sounds/reel/reel.mp3"),
		],
		reel_start: require("./sounds/reel_start.mp3"),
		anticipate: {
			12: require("./sounds/anticipate/LongerSpin.mp3"),
		},
		multi_sweep: require("./sounds/MultiSweep.mp3"),
		multi_sweep_twinkle: require("./sounds/MultiSweepBell.mp3"),
		buttons: {
			denoms: {
				denom_0: require("./sounds/buttons/denoms/denom-12.mp3"),
				denom_1: require("./sounds/buttons/denoms/denom-11.mp3"),
				denom_2: require("./sounds/buttons/denoms/denom-10.mp3"),
				denom_3: require("./sounds/buttons/denoms/denom-9.mp3"),
				denom_4: require("./sounds/buttons/denoms/denom-8.mp3"),
				denom_5: require("./sounds/buttons/denoms/denom-7.mp3"),
				denom_6: require("./sounds/buttons/denoms/denom-6.mp3"),
			},
			coins: {
				bet_0: require("./sounds/buttons/coins/Bet_1.mp3"),
				bet_1: require("./sounds/buttons/coins/Bet_2.mp3"),
				bet_2: require("./sounds/buttons/coins/Bet_3.mp3"),
				bet_3: require("./sounds/buttons/coins/Bet_4.mp3"),
				bet_4: require("./sounds/buttons/coins/Bet_5.mp3"),
				bet_5: require("./sounds/buttons/coins/Bet_6.mp3"),
				bet_6: require("./sounds/buttons/coins/Bet_6.mp3"),
				bet_7: require("./sounds/buttons/coins/Bet_6.mp3"),
				bet_8: require("./sounds/buttons/coins/Bet_6.mp3"),
			},
			max: require("./sounds/buttons/max_bet.mp3"),
			sound: require("./sounds/buttons/volume.mp3"),
			help: require("./sounds/buttons/open.mp3"),
			close: require("./sounds/buttons/close.mp3"),
			next: require("./sounds/buttons/next.mp3"),
			prev: require("./sounds/buttons/prev.mp3"),
		},
		freespin: {
			// default intro sound has bad timing for this title, used in freespin init
			intro: require("./sounds/freespin/BgmIntro.mp3"),
			background2: require("./sounds/freespin/BgmFg.mp3"),
			smallTrigger: require("./sounds/freespin/FeatureTriggerShort.mp3"),
			countUp: require("./sounds/freespin/FreeGameCountUp.mp3"),
			
		},
		mystery: {
			afterFlames: require("./sounds/mystery/AfterFlameAdd.mp3"),
			bannerIntroFlames: require("./sounds/mystery/BannerIntroFlames.mp3"),
			duringExtraBell: require("./sounds/mystery/DuringXtraBell.mp3"),
			effectDuring: require("./sounds/mystery/EffectDuring3.mp3"),
			postBigAdd: require("./sounds/mystery/PostBigAdd.mp3"),
			postBigAdd2: require("./sounds/mystery/PostBigAdd2.mp3"),
			postEfxSmall: require("./sounds/mystery/PostEfxSmall.mp3"),
			sSound2: require("./sounds/mystery/SSound2.mp3"),
		},
		quake: require("./sounds/rumble.mp3"),
		win: {
			// decor : "decor",
			intro1: require("./sounds/win/intro1.mp3"),
			intro2: require("./sounds/win/intro2.mp3"),
			win_1: require("./sounds/win/Level1_WinKP35V1_02.mp3"),
			win_2: require("./sounds/win/Level2_WinKP35V1_11.mp3"),
			win_3: require("./sounds/win/Level3_WinKP35V1_14.mp3"),
			bigwin_1: require("./sounds/win/Level4_WinKP35V1_17.mp3"),
			bigwin_2: require("./sounds/win/Level5_WinKP35V1_23.mp3"),
			bigwin_3: require("./sounds/win/Level6_WinKP35V1_30.mp3"),
		},
		konami_base_fallback: require("./sounds/konami_base_fallback.mp3"),
	});

	game.specials = {
		12: { reels: [ 0, 1, 2, 3, 4 ], min: 2, needs: 3 },
	};
	
	game.pays.forceCycles = true;
	let numCoins = 31;
	let coinTimeout = 0;
	let celebrateTimeout = 0;
	let startCelebrateTimeout = 0;
	let bonusFinished = false;
	let realReels = [];
	let mysteryReveal = null;
	let miniReveal = null;
	let recovered = false;
	
	// Div to allow reel background to be an image
	let reels = $.div("reels");
	reels.prependTo(game.container);
		
	// Divs for Konami Logos
	let actionLogo = $.div("action-logo");
	actionLogo.appendTo(game.container);
	
	let xtraReward = $.div("xtra-reward");
	xtraReward.appendTo(game.container);
	
	let fortune = {};
		
	let freespin = game.features.freespin = game.generateFreespin({ symbol: 12, introTime: 1, banners: 1, noAutomatedSounds: true, outroTime: 500 });
	
	freespin.dimensions = {
		width:	1920,
		height: 1222,
		font: 32,
	};
	
	// set to false at the beginning of each spin, conditionally set to true when pays are shown
	let line_indicators = game.frame.line_indicators = [];
	let bubbles = 0;
	
	game.panel.dialog.pager.bubbles.on("click", function() {
		if (bubbles > game.panel.dialog._page) {
			game.sounds.play([ "buttons", "prev" ]);
			bubbles = game.panel.dialog._page;
		}
		else if (bubbles < game.panel.dialog._page) {
			game.sounds.play([ "buttons", "next" ]);
			bubbles = game.panel.dialog._page;
		}
	});
	
	// Help screen close
	game.panel.dialog.pager.exit.on("click", function() {
		game.sounds.play([ "buttons", "close" ]);
		bubbles = 0;
	});
	
	// Help screen right arrow click
	game.panel.dialog.pager.right.on("click", function() {
		game.sounds.play([ "buttons", "next" ]);
		bubbles = game.panel.dialog._page;
	});
	
	// Help screen left arrow click
	game.panel.dialog.pager.left.on("click", function() {
		game.sounds.play([ "buttons", "prev" ]);
		// noinspection ReuseOfLocalVariableJS
		bubbles = game.panel.dialog._page;
	});
	
	// Force background for wild feature to fill screen
	game.on("scale", function() {
	});
	
	game.on("ui", function(e) {
		let recovery = e.detail.recall;
		let symbols = [ 6, 7, 8, 9, 10, 11 ];

		// Add big win coins
		fortune.coins = $.div().addClass("fortune coins").appendTo(game.pays);
		fortune.coins.coins  = [];
		fortune.coins.coin = 0;
		
		// Adding xtra reward cost to panel
		game.feature.cost = e.detail.xtra_reward.cost;
		
		game.panel.disableBigWins([ 1, 3, 4, 6, 10, 14 ]);
		game.panel.bigwin.breakpoints[4] = 20;
		
		for (let i = 0; i < numCoins; i++) {
			fortune.coins.coins[i] = $.div().addClass("coin-" + i).appendTo(fortune.coins);
		}

		fortune.stacks = $.div().addClass("fortune stacks").appendTo(game.pays);
		
		line_indicators[0] = $.div().addClass("line_indicator left").prependTo(game.pays);
		line_indicators[1] = $.div().addClass("line_indicator right").prependTo(game.pays);

		mysteryReveal = $.div().addClass("mysteryReveal").appendTo(game.frame);

		mysteryReveal.symbol = {};
		mysteryReveal.symbol.background = $.div().addClass("mystery background").appendTo(mysteryReveal);
		mysteryReveal.symbol.symbol = $.div().addClass("mystery symbol").appendTo(mysteryReveal);
		mysteryReveal.symbol.reveal = $.div().addClass("mystery reveal").appendTo(mysteryReveal);
		mysteryReveal.symbol.frame = $.div().addClass("mystery frame").appendTo(mysteryReveal);
		mysteryReveal.info = $.div().addClass("info").appendTo(mysteryReveal);

		miniReveal = $.div().addClass("miniReveal").appendTo(game.frame);

		miniReveal.symbol = {};
		miniReveal.symbol.symbol = $.div().addClass("mystery symbol").appendTo(miniReveal);
		miniReveal.symbol.frame = $.div().addClass("mystery frame").appendTo(miniReveal);
		miniReveal.info = $.div().addClass("info").appendTo(miniReveal);

		if (recovery) {
			recovered = true;
		}

		if (recovery && recovery.actions[0].response.mystery) {
			game.addClass("bonus");
		}

		if (recovery && recovery.actions[0].response.delayTrigger) {
			let response = recovery.actions[0].response;

			for (let reel = 0; reel < response.matrix.length; reel++) {
				for (let symbol = 0; symbol < response.matrix[reel].length; symbol++) {
					if (symbols.indexOf(response.matrix[reel][symbol]) !== -1 ) {
						response.matrix[reel][symbol] = response.mystery;
					}
				}
			}
		}
	});
	
	// Add extra reward cost
	game.on("bet", function(e) {
		e.detail.feature_cost = game.feature.cost;
	});
	
	game.on("ready", function() {
		// Default bell timing is not right for this title, plays on freespin init
		setTimeout(function() {
			if (!game.sounds.fallback) {
				game.sounds.sounds.bell = null;
			}
		}, 15);
	});
	
	game.spindle.on("spin", function() {
		recovered = false;
		// Stop big win celebration
		game.endCelebrate();

		if (!game.feature.active && game.hasClass("bonus")) {
			game.removeClass("bonus");
		}

		// Lock panel to prevent slamming during wild feature
		if (game.panel.type === "desktop") {
			game.panel.info.turbo.addClass("lock");
		}

		else {
			game.panel.settings.turbo.addClass("lock");
		}

		game.panel.disable("lock");
	});
	
	game.on("reel_stop", function(e) {
		let reel = e.detail.index;

		fitToFrame(reel);
	});

	game.on("spin_init", function(e) {
		let lockDelay = 0;

		// REPLACE FEATURE
		this.spindle.attr("class", "s" + this.last.replace);
		
		// Force Logo to show
		if (!game.feature.active) {
			game.messaging.show("logo");
		}

		if (game.last.mystery !== undefined && !game.last.delayTrigger && !recovered) {
			// Force reels to continue spinning
			game.spindle.stop = null;
			let symbols = [ 6, 7, 8, 9, 10, 11 ];
			lockDelay = 9000;

			if(game.inRecall) {
				return;
			}

			game.addClass("bonus");
			game.sounds.play([ "mystery", "effectDuring" ]);

			//Show mystery intro
			mysteryReveal.addClass("show");
			mysteryReveal.symbol.symbol.attr("class", "mystery symbol-" + game.last.mystery);

			setTimeout(function () {
				mysteryReveal.removeClass("show");

				setTimeout(function () {
					mysteryReveal.addClass("reveal");
				}, 10);
			}, 2500);

			setTimeout(function () {
				//Replace all royals on the reel with mystery symbol
				for (let reel = 0; reel < game.spindle.reels.length; reel++) {
					let tempReal = [];
					let realIndex = game.spindle.reels[reel].real.index;
					realReels[reel] = [];

					for (let index = 0; index < game.spindle.reels[reel].real.length; index++) {
						tempReal[index] = game.spindle.reels[reel].real[index];
						realReels[reel][index] = tempReal[index];
						realReels[reel].index = realIndex;

						if (symbols.indexOf(tempReal[index]) !== -1) {
							tempReal[index] = game.last.mystery;
						}
					}

					game.spindle.reels[reel].real = tempReal;
					game.spindle.reels[reel].real.index = realIndex;
					game.spindle.reels[reel].update();
				}
			}, 3000);

			setTimeout(function () {
				mysteryReveal.removeClass("reveal");
			}, 5000);

			setTimeout(function () {
				//Allow Reels to stop
				game.spindle.stop = 0;
			}, 6000);
		}
		
		setTimeout(function () {
			// Allow slamming if wild feature not active
			if (game.panel.type === "desktop") {
				game.panel.info.turbo.removeClass("lock");
			}
			
			else {
				game.panel.settings.turbo.removeClass("lock");
			}
			
			game.panel.state = null;
			
			if (!recovered && (feature.active || game.last.scatters.counts[12] > 2)) {
				game.panel.disable("freespin");
			}
		}, lockDelay);
	});
		
	game.on("spin_ready", function() {
		
	});
	
	game.on("spin_pre_done", function() {

		if (game.last.mystery !== undefined && game.last.delayTrigger && !game.last.mystTriggered && !recovered) {
			let symbols = [ 6, 7, 8, 9, 10, 11 ];
			game.last.delayBonus = true;
			game.last.delayWin = true;

			setTimeout(function () {
				game.addClass("bonus");
				game.sounds.play([ "mystery", "postEfxSmall" ]);

				if (game.last._win >= game.last._cost * 30 && Math.round(Math.random())) {
					game.sounds.play([ "mystery", "postBigAdd" ]);
				}

				for (let reel = 0; reel < game.last.matrix.length; reel++) {
					for (let symbol = 0; symbol < game.last.matrix[reel].length; symbol++) {
						if (symbols.indexOf(game.last.matrix[reel][symbol]) !== -1 ) {
							game.frame.reels[reel].symbols[symbol].addClass("frame");
							setTimeout(function () {
								game.frame.reels[reel].symbols[symbol].addClass("reveal");
								game.spindle.reels[reel].window.symbols[symbol].attr("class", "symbol symbol-" + game.last.mystery);
							}, 1000);
						}
					}
				}
			}, 1000);

			setTimeout(function () {
				game.sounds.play([ "mystery", "sSound2" ]);
			}, 4000);

			setTimeout(function () {
				game.last.delayBonus = false;
				game.last.delayWin = false;
				game.last.mystTriggered = true;
				spinDone();
			}, 7000);
		}

		else if (game.last.mystery !== undefined && !game.last.delayTrigger && game.last._win >= game.last._cost * 20 && !game.last.mystTriggered && !recovered) {
			game.last.delayWin = true;
			game.last.delayBonus = true;

			game.sounds.play([ "mystery", "sSound2" ]);

			setTimeout(function () {
				game.last.delayWin = false;
				game.last.delayBonus = false;
				game.last.mystTriggered = true;

				spinDone();
			}, 3000);
		}

		// If freegames triggered, show Intro screen before anything
		else if (!game.feature.active && !game.last.introShown && game.last.scatters.counts[12] > 2 && !bonusFinished) {
			game.last.introShown = true;
			game.last.delayBonus = true;
			showBonusIntro(6000);
		}
		
		// If retriggered freespins, show retrigger banner
		else if (game.feature.active && game.last.scatters.counts[12] > 2) {
			showRetriggerBanner(3000);
		}
		
		// Check for big wins
		else if (!game.last.delayed && !recovered) {
			decideCoins();
		}
	});
	
	game.on("spin_done", function() {
		// If panel is locked, unlock panel
		if (game.panel.state === "lock" ) {
			if (game.panel.type === "desktop") {
				game.panel.info.turbo.removeClass("lock");
			}
			
			else {
				game.panel.settings.turbo.removeClass("lock");
			}
			game.panel.state = "spin";
			
			if (!game.feature.active) {
				game.panel.disabled = false;
			}
		}

		if (game.last.mystery !== undefined && !game.last.delayTrigger && !game.inRecall) {
		    for (let reel = 0; reel < game.spindle.reels.length; reel++) {
		        game.spindle.reels[reel].real = realReels[reel];
				game.spindle.reels[reel].update();
            }
        }
	});
	
	game.on("round_complete", function() {
		// Stop big win celebration
		game.endCelebrate();
		
		// Start bonus after panel is finished rolling up
		if (game.last.bonuses && game.last.bonuses.length && !bonusFinished) {
			game.feature.begin(game.last.bonuses.pop());
			game.last.triggeredBonus = true;
		}
	});
	
	freespin.on("init", function(e) {
		if (game.old) {
			game.old.quickTransition = false;
		}
		
		game.panel.hide(true);
		game.sounds.play([ "freespin", "smallTrigger" ]);
		
		if (!game.sounds.fallback) {
			game.sounds.sounds.freespin.background = null;
		}
	});
	
	freespin.on("begin", function(e) {
		// Change message dipslayed on spin button per Konami"s request
		this.play.message.html("Press to Start");
	});
	
	freespin.on("spin", function() {
		// Change background to bonus background
		if (!this.swappedTheBackground) {
			this.swappedTheBackground = true;
			
			if (!game.sounds.fallback) {
				game.sounds.sounds.freespin.background = game.sounds.sounds.freespin.background2;
			}
			
			game.sounds.play([ "freespin", "background" ], true);
		}
	});
	
	freespin.on("finish", function() {
		game.attr("class", "");
		this.swappedTheBackground = false;
		
		setTimeout(function() {
			game.messaging.show("logo");
			
			if (game.autoplay.isActive()) {
				setTimeout(function() {
					game.play();
				}, 2000);
			}
			
			game.panel.setCredits(game.last.credits);
		}, 1500);
	});
	
	// Begins big win celebration
	game.startCelebrate = function() {
		fortune.stacks.addClass("shimmer");
		
		celebrateTimeout = setTimeout(function() {
			celebrateTimeout = setTimeout(function() {
				fortune.coins.addClass("flip");
				coinTimeout = setInterval(function() {
					game.flipCoins();
				}, (2000 / (numCoins - 2)));
			}, 0);
		}, 450);
	};
	
	// Displays coins for big win celebration
	game.flipCoins = function() {
		var current = fortune.coins.coin;
		var coin = Math.floor(Math.random() * (6 - 1 + 1)) + 1; // coin image
		var left = Math.floor(Math.random() * (85 - 15 + 1)) + 15; // css displacement
		
		fortune.coins.coins[current].css("left", 50 + "%");
		fortune.coins.coins[current].attr("class", "flip coin-" + coin);
		
		setTimeout(function() {
			fortune.coins.coins[current].css("left", left + "%");
		}, 250);
		
		setTimeout(function() {
			fortune.coins.coins[current].removeClass("flip");
		}, 2000);
		
		fortune.coins.coin = ((fortune.coins.coin + 1) % fortune.coins.coins.length);
	};
	
	// Clear all set timeouts and ends big win celebration
	game.endCelebrate = function() {
		clearInterval(coinTimeout);
		clearInterval(celebrateTimeout);
		clearInterval(startCelebrateTimeout);
		
		fortune.coins.removeClass("flip");
		// fortune.top.removeClass("fiz");
		fortune.stacks.removeClass("shimmer");
		
		game.removeClass("quake");
		game.removeClass("quakeVert");
	};
	
	// End big win celebraton on slam
	game.panel.spin.on("click", function() {
		game.endCelebrate();
		
		game.removeClass("quakeVert");
		game.removeClass("quake");
	});
	
	game.on("recall_action", function(config) {
	});
	
	// Prevents spin games big win celebration and modifies the duraton of the win sounds and rollup
	game.panel.disableBigWins = function(durations) {
		this.bigwin.celebrations = {};
		
		for (var i = 0; i < this.bigwin.levels.length; i++) {
			this.bigwin.levels[i] = [ this.bigwin.levels[i][this.bigwin.levels[i].length - 1] ];
			
			if ( this.bigwin.levels[i][0].duration ) {
				this.bigwin.levels[i][0].duration = undefined;
				delete this.bigwin.levels[i][0].duration;
			}
			
			if (durations && durations[i]) {
				this.bigwin.levels[i][0].duration = durations[i];
			}
			
			if ( this.bigwin.levels[i][0].celebration ) {
				this.bigwin.levels[i][0].celebration = undefined;
				delete this.bigwin.levels[i][0].celebration;
			}
		}
	};
	
	// Check for big wins and starts celebration as neccessary
	function decideCoins() {
		var decide = 0;
		var factor = 5;
		var winFactor = 0;
		var win = game.last.win;
		
		if (game.last._cost) {
			winFactor = win / (game.last._cost);
		}
		else if (game.old && game.old._cost) {
			winFactor = win / (game.old._cost);
		}
		else if (game.old && game.old._cost === 0) {
			winFactor = win / ((game.panel.lines.get()) * game.panel.coins.get());
		}
		
		for (decide = 0; decide < game.panel.bigwin.breakpoints.length; decide++) {
			if (winFactor < game.panel.bigwin.breakpoints[decide]) {
				break;
			}
		}

		// If win meets or exceeds big win amount start big win celebration
		if (decide >= factor) {
			game.last.delayWin = true;
			game.frame.addClass("win");
			game.addClass("quake");
			game.addClass("quakeVert");
			game.sounds.play("quake");
			
			startCelebrateTimeout = setTimeout(function() {
				game.startCelebrate();
				game.last.delayWin = false;
				game.last.delayed = true;
				
				if (game.last.bonuses && game.last.bonuses.length || game.last.triggereBonus) {
					game.last.delayBonus = true;
				}

				spinDone();
				game.frame.addClass("win");
				game.removeClass("quake");
				game.removeClass("quakeVert");
				
				if (game.last.bonuses && game.last.bonuses.length) {
					game.pays.show();
				}
			}, 2000);
		}
	}
	
	// Displays freegame intro before rollup or wins are displayed
	function showBonusIntro(time) {
		let message = $.div().addClass("false-messages").appendTo(game.pays);
		let text = $.div().addClass("text");

		game.last.quickTransition = true;
		message.addClass("intro");
		message.addClass("_" + game.last.scatters.counts[12]);
		text.appendTo(message);
		game.sounds.play(["mystery", "bannerIntroFlames"]);
		game.sounds.play("konami_bell");
		game.sounds.play(["mystery", "postBigAdd2"]);

		setTimeout(function () {
			game.sounds.play("bannerIntro2");
		}, 1500);
		
		setTimeout(function() {
			message.attr("class", "false-messages");
			message.remove();

			game.messaging.hide("logo");
			game.panel.setWin(game.last.win);
			game.last.delayBonus = true;
			spinDone();
		
			if (game.last.scatters.counts[12] < 5) {
				game.pays.show();
			}
		}, time);
	}
	
	// Places scatter symbol on frame so they appear above the frames edges
	function fitToFrame(index) {
		for (var col = 0; col < game.config.reels; col++) {
			let rowLength = game.config.rows;
			
			for (var row = 0; row < rowLength; row++) {
				if (game.last.matrix[typeof index === "number" ? index : col][row] === 12) {
					game.frame.reels[typeof index === "number" ? index : col].symbols[row].addClass("symbol symbol-12");
				}
			}
		}
	}
	
	// Displays retirgger banner in freegames
	function showRetriggerBanner(time) {
		let message = $.div().addClass("false-messages").appendTo(game.pays);
		let text = $.div().addClass("text");
		game.sounds.play(["mystery", "bannerIntroFlames"]);
		game.sounds.play("konami_bell");
		game.sounds.play(["mystery", "postBigAdd2"]);
		
		message.addClass("intro");
		message.addClass("_" + game.last.scatters.counts[12]);
		text.appendTo(message);
		
		setTimeout(function() {
			message.attr("class", "false-messages");
			message.remove();
		}, time);
	}
	
	// recover cost
	game.on("ui", function() {
		if (!game.last._cost) {
			setTimeout(function() {
				var bet = game.panel.getBet();
				game.last._cost = bet.coins * bet.lines;
			}, 1);
		}
	});
	// --new
});



/** WEBPACK FOOTER **
 ** ./public-src/game.js
 **/